module.exports = __webpack_public_path__ + "img/cmi_button.b27057e2.png";